module.exports = __webpack_public_path__ + "img/haunted.b2a42ea7.png";